import { useEffect, useState, useCallback, ChangeEvent, FormEvent, useMemo } from "react";
import { MRT_ColumnDef } from "material-react-table";

import MATERIAL_TABLE_CONTAINER from "../../../main_components/material_table/table_container";

import { PURCHASE_ORDERS_INTERFACE } from "../../purchase_orders/interface/interface";
import { refresh_token } from "../../../main_components/tokens/tokenrefreshNewMethod";
import { paginatedApiCall } from "../../../main_components/pagination/paginated_api_call";
import { UPDATE_NULL_IDENTIFIERS } from "../../../main_components/methods_v2/auxiliary_functions_new_method";

import RuleFolderIcon from '@mui/icons-material/RuleFolder';
import { staus_purchase_order_post } from "../../../services/expenses/purchase_orders";
import EXTRA_ORDER_DETAILS from "./auxiliar_table/extra_order_details";
import EXTRA_INVOICE_DETAILS from "./auxiliar_table/extra_invoice_details";
import SUBTOTAL_MISMATCH_DETAILS from "./auxiliar_table/subtotal_mismatch_details";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import MODAL_TABLE from "../../../main_components/modal/modal_Table";
import Typography from "@mui/material/Typography";

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { supplier_orders_get } from "../../../services/expenses/purchase_orders";
import { findInObjectDisplayRole } from "../../../Content/verify_role";
export default function SUPPLIER_ORDERS(props: any) {
    const [order, setOrder] = useState<any>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [activeTab, setActiveTab] = useState(0);
    const [stausOrder, setStausOrder] = useState<any>([]);
    const [modalT, setmodalT] = useState<boolean>(false);
    const [hasErrors, setHasErrors] = useState(false);
    const [id_force, setId_force] = useState<string | number>(0);

    const update_identifiers = [
        { id: "number" },
        { date_register: "string" },
        { date_document: "string" },
        { total: "number" },
        { form_of_payment: "string" },
        { payment_method: "string" },
        { supplier_rfc: "string" },
        { supplier_name: "string" },
        { note: "string" },
        { rows: "number" },
    ];

    const verifyToken = async (): Promise<boolean> => {
        try {
            return await refresh_token();
        } catch (error) {
            console.error("Error al verificar el token:", error);
            return false;
        }
    };

    const fetchPurchaseOrders = async (): Promise<PURCHASE_ORDERS_INTERFACE[]> => {
        try {
            const rawResponse = await supplier_orders_get({ rfc: props?.rfc });
            return UPDATE_NULL_IDENTIFIERS(
                rawResponse.data,
                update_identifiers
            ) as PURCHASE_ORDERS_INTERFACE[];
        } catch (error) {
            console.error("Error al obtener los datos del usuario:", error);
            return [];
        }
    };

    const handlePurchaseOrders = async (event?: React.SyntheticEvent): Promise<void> => {
        event?.preventDefault();
        setIsLoading(true);
        setmodalT(true);
        setOrder([]);
        const isTokenValid = await verifyToken();
        if (!isTokenValid) {
            setIsLoading(true);
            setmodalT(true);
            console.error("Token inválido o expirado. Deteniendo el proceso...");
            console.log("Actualizando token...");
            setTimeout(() => {
                handlePurchaseOrders();
            }, 1000);
            return;
        }
        const data = await fetchPurchaseOrders();
        setOrder(data);
        setIsLoading(false);
        setmodalT(false);
    };

    const relation_order = async (id: number | string) => {
        setmodalT(true);
        try {
            const response = await staus_purchase_order_post(id, props?.invoice, { check_status_and_details: true });
            setStausOrder(response.data);
            if (response.data.error_detail_counter === 0) {
                await staus_purchase_order_post(id, props?.invoice, { check_status_and_details: false });
                if (props?.redirect === "SUPPLIER_INVOICE_TS") {
                    window.location.href = "/SUPPLIER_INVOICE_TS";
                } else {
                    window.location.href = "/INVOICE_UP_LOADER_TS";
                }
            }
        } catch (error: any) {
            console.error("Error al obtener los datos del usuario:", error);
            setStausOrder([])
            alert(error?.response?.data?.errorMessage?.es);
        } finally {
            setmodalT(false);
        }
    };



    const relation_order_force = async () => {
        setmodalT(true);
        try {
            await staus_purchase_order_post(id_force, props?.invoice, { check_status_and_details: false });
            if (props?.redirect === "SUPPLIER_INVOICE_TS") {
                window.location.href = "/SUPPLIER_INVOICE_TS";
            } else {
                window.location.href = "/INVOICE_UP_LOADER_TS";
            }
        } catch (error: any) {
            console.error("Error al obtener los datos del usuario:", error);
            alert(error?.response?.data?.errorMessage?.es);
        } finally {
            setmodalT(false);
        }
    };



    useEffect(() => {
        if (props?.rfc !== undefined && props?.rfc !== null) {
            handlePurchaseOrders();
        }
    }, [props?.rfc]);


    const columns: MRT_ColumnDef<PURCHASE_ORDERS_INTERFACE>[] = useMemo(
        () => [
            {
                id: "AC.",
                header: "AC.",
                size: 100,
                enableFilters: false,
                enableColumnFilters: false,
                enableColumnFiltering: false,
                enableEditing: false,
                enableColumnFilterModes: false,
                enableRowOrdering: false,
                enableGrouping: false,
                enableColumnDragging: false,
                enableColumnActions: false,
                accessorFn: (d) => {
                    return (
                        <div>
                            <span
                                title="Relacionar Orden de compra"
                                onClick={() => { setId_force(d.id); relation_order(d.id) }}>
                                <RuleFolderIcon className="icons_general_delete" />
                            </span>
                        </div>
                    );
                },
                muiTableHeaderCellProps: { align: "center" },
                muiTableBodyCellProps: { align: "center" },
            },
            {
                header: "No. Orden",
                accessorKey: "order_number",
                id: "order_number",
                size: 120,
            },
            {
                header: "F. Registro",
                accessorKey: "date_register",
                id: "date_register",
                size: 130,
            },
            {
                header: "F. Documento",
                accessorKey: "date_document",
                id: "date_document",
                size: 140,
            },
            {
                header: "Total",
                accessorKey: "total",
                id: "total",
            },
            {
                header: "Forma de Pago",
                accessorKey: "form_of_payment",
                id: "form_of_payment",
            },
            {
                header: "Método de Pago",
                accessorKey: "payment_method",
                id: "payment_method",
            },
            {
                header: "RFC Proveedor",
                accessorKey: "supplier_rfc",
                id: "supplier_rfc",
            },
            {
                header: "Proveedor",
                accessorKey: "supplier_name",
                id: "supplier_name",
            },
            {
                header: "Nota",
                accessorKey: "note",
                id: "note",
            },
            {
                header: "N. Conceptos",
                accessorKey: "rows",
                id: "rows",
            },
        ],
        [order]
    );


    console.log(findInObjectDisplayRole(["PU:OR3.FR"]))

    useEffect(() => {
        const hasErrorDetails =
            stausOrder?.error_detail_counter > 0 &&
            (
                (stausOrder?.extra_order_details?.length || 0) > 0 ||
                (stausOrder?.extra_invoice_details?.length || 0) > 0 ||
                (stausOrder?.subtotal_mismatch_details?.length || 0) > 0
            );
        setHasErrors(hasErrorDetails);
        props?.setErrors_status(stausOrder?.error_detail_counter === undefined ? false : stausOrder.error_detail_counter > 0 ? true : false)
    }, [stausOrder]);

    return (
        <div>

            <MODAL_TABLE
                open={true}
                message={""}
                message2={""}
                modalGeneral={false}
                modalT={modalT}
            ></MODAL_TABLE>

            {!hasErrors && (
                <MATERIAL_TABLE_CONTAINER
                    key={"INVOICE_UP_LOADER_TS"}
                    columns={columns}
                    data={order}
                    breadcrumbs={props?.breadcrumbs ? [{ label: "ORDENES DE COMPRA DISPONIBLES", path: null }] : null}
                    modalT={modalT}
                    isLoading={isLoading}
                    search_filters={<div></div>}
                    component_header={<div></div>}
                    file_name_export="FACTURAS"
                    update_identifiers={[]}
                />
            )}

            {hasErrors && (
                <>
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        gap={1}
                        p={2}
                        mb={4}
                        bgcolor="#EEF4FF"
                        borderRadius="8px"
                    >
                        {/* Sección izquierda: ícono + texto */}
                        <Box display="flex" alignItems="center" gap={1}>
                            <InfoOutlinedIcon color="primary" />
                            <Typography fontSize="14px" color="#344054">
                                SE ENCONTRARON <strong>{stausOrder?.error_detail_counter}</strong> DIFERENCIAS ENTRE LA ORDEN DE COMPRA Y LA FACTURA.
                            </Typography>
                        </Box>

                        {/* Sección derecha: botones alineados */}
                        <Box display="flex" gap={1}>
                            <Button
                                variant="contained"
                                sx={{
                                    fontSize: "13px",
                                    fontWeight: "bold",
                                    borderRadius: "6px",
                                    px: 2,
                                    py: 1,
                                    bgcolor: "green",
                                    "&:hover": {
                                        bgcolor: "#0b6e3f"
                                    }
                                }}
                                onClick={() => {
                                    setHasErrors(false);
                                    console.log("Relacionar otra orden...");
                                }}
                            >
                                RELACIONAR OTRA ORDEN DE COMPRA
                            </Button>

                            <Button
                                variant="contained"
                                // style={{ display: findInObjectDisplayRole(["PU:OR3.FR", "PU:OR2.FR", "PU:OR1.FR", "PU:OR3.FR2", "PU:OR2.FR2", "PU:OR1.FR2", "PU:OR3.FR3", "PU:OR2.FR3", "PU:OR1.FR3"]) }}

                                sx={{
                                    fontSize: "13px",
                                    fontWeight: "bold",
                                    borderRadius: "6px",
                                    px: 2,
                                    py: 1,
                                    bgcolor: "red",
                                    "&:hover": {
                                        bgcolor: "red"
                                    }
                                }}
                                onClick={() => {
                                    relation_order_force();
                                    console.log("Forzando relación...");
                                }}
                            >
                                FORZAR RELACIÓN
                            </Button>
                        </Box>
                    </Box>



                    <Box
                        display="start-flex"
                        border="1px solid #D0D5DD"
                        borderRadius="10px"
                        p="3px"
                        bgcolor="#F9FAFB"
                        mt={2}
                        mx={2}
                    >
                        {stausOrder?.extra_order_details?.length > 0 && (
                            <Button
                                onClick={() => setActiveTab(0)}
                                sx={{
                                    borderRadius: "8px",
                                    px: 2,
                                    py: 1,
                                    minWidth: "150px",
                                    backgroundColor: activeTab === 0 ? "#173B8C" : "transparent",
                                    color: activeTab === 0 ? "#fff" : "#667085",
                                    fontWeight: activeTab === 0 ? "bold" : "normal",
                                    boxShadow: activeTab === 0 ? "0px 1px 2px rgba(16, 24, 40, 0.05)" : "none",
                                    "&:hover": {
                                        backgroundColor: activeTab === 0 ? "#102b6e" : "#F0F2F5"
                                    },
                                    textTransform: "none",
                                    fontSize: "14px"
                                }}
                            >
                                CONCEPTOS NO ENCONTRADOS EN LA FACTURA
                            </Button>
                        )}

                        {stausOrder?.extra_invoice_details?.length > 0 && (

                            <Button
                                onClick={() => setActiveTab(1)}
                                sx={{
                                    borderRadius: "8px",
                                    px: 2,
                                    py: 1,
                                    minWidth: "150px",
                                    backgroundColor: activeTab === 1 ? "#173B8C" : "transparent",
                                    color: activeTab === 1 ? "#fff" : "#667085",
                                    fontWeight: activeTab === 1 ? "bold" : "normal",
                                    boxShadow: activeTab === 1 ? "0px 1px 2px rgba(16, 24, 40, 0.05)" : "none",
                                    "&:hover": {
                                        backgroundColor: activeTab === 1 ? "#102b6e" : "#F0F2F5"
                                    },
                                    textTransform: "none",
                                    fontSize: "14px"
                                }}
                            >
                                CONCEPTOS EXTRA EN LA FACTURA
                            </Button>
                        )}

                        {stausOrder?.subtotal_mismatch_details?.length > 0 && (
                            <Button
                                onClick={() => setActiveTab(2)}
                                sx={{
                                    borderRadius: "8px",
                                    px: 2,
                                    py: 1,
                                    minWidth: "120px",
                                    backgroundColor: activeTab === 2 ? "#173B8C" : "transparent",
                                    color: activeTab === 2 ? "#fff" : "#667085",
                                    fontWeight: activeTab === 2 ? "bold" : "normal",
                                    boxShadow: activeTab === 2 ? "0px 1px 2px rgba(16, 24, 40, 0.05)" : "none",
                                    "&:hover": {
                                        backgroundColor: activeTab === 2 ? "#102b6e" : "#F0F2F5"
                                    },
                                    textTransform: "none",
                                    fontSize: "14px"
                                }}
                            >
                                DIFERENCIAS EN PRECIOS
                            </Button>
                        )}

                    </Box>

                    <Box px={2} mt={2}>
                        {activeTab === 0 && stausOrder?.extra_order_details?.length > 0 && (
                            <EXTRA_ORDER_DETAILS detaills={stausOrder.extra_order_details} />
                        )}

                        {activeTab === 1 && stausOrder?.extra_invoice_details?.length > 0 && (
                            <EXTRA_INVOICE_DETAILS detaills={stausOrder.extra_invoice_details} />
                        )}

                        {activeTab === 2 && stausOrder?.subtotal_mismatch_details?.length > 0 && (
                            <SUBTOTAL_MISMATCH_DETAILS detaills={stausOrder.subtotal_mismatch_details} />
                        )}
                    </Box>
                </>
            )}
        </div>
    );
}
